import Layout from "@/components/feature/Layout";

export default function IletisimPage() {
  return (
    <Layout>
      <section className="relative min-h-[360px] md:min-h-[420px] flex items-center">
        <div className="absolute inset-0">
          <img
            src="/assets/images/iletisim.jpg"
            alt="Day Temizlik Adana iletişim"
            className="w-full h-full object-cover opacity-20"
          />
          <div className="absolute inset-0" style={{ background: 'linear-gradient(90deg, rgba(3, 27, 63, 0.85), rgba(3, 27, 63, 0.45))' }}></div>
        </div>
        <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 py-14 md:py-20">
          <div className="max-w-7xl mx-auto">
            <span className="inline-block bg-[#2EA44F]/90 text-white text-xs font-medium px-3 py-1.5 rounded-full mb-4">
              İletişim
            </span>
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-white leading-tight mb-4">
              Day Temizlik Adana ile hemen iletişime geçin
            </h1>
            <p className="text-base md:text-lg text-[#EAF2FF] leading-relaxed mb-6 max-w-2xl">
              Daire temizliği, bina ve site temizliği, inşaat sonrası temizlik, koltuk yıkama, halı yıkama, ilaçlama ve yönetim hizmetleri için hızlıca bize ulaşabilirsiniz.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <a href="tel:05539591940" className="inline-flex items-center justify-center gap-2 bg-[#2EA44F] text-white px-6 py-3 rounded-md text-sm font-semibold hover:bg-[#2EA44F]/90 transition-colors whitespace-nowrap">
                <i className="ri-phone-line w-4 h-4 flex items-center justify-center"></i>
                Hemen Ara
              </a>
              <a href="https://wa.me/905539591940" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 bg-white text-[#0A2F63] px-6 py-3 rounded-md text-sm font-semibold hover:bg-[#EAF2FF] transition-colors whitespace-nowrap">
                <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center"></i>
                WhatsApp'tan Yaz
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="py-14 md:py-20 bg-background-50">
        <div className="w-full px-4 md:px-6 lg:px-10">
          <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12">
            <div>
              <div className="relative rounded-lg overflow-hidden">
                <img
                  src="/assets/images/iletisim-visual.jpg"
                  alt="Day Temizlik Adana profesyonel ekip"
                  className="w-full h-80 md:h-96 object-cover"
                />
              </div>
              <p className="text-sm text-foreground-600 mt-4 text-center italic">
                "Planlı, hijyen odaklı ve profesyonel hizmet anlayışı"
              </p>
            </div>

            <div className="space-y-4">
              <div className="bg-white rounded-lg p-5 md:p-6 border border-gray-100 shadow-sm">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#0A2F63]/10 rounded-lg shrink-0">
                    <i className="ri-phone-line w-5 h-5 flex items-center justify-center text-[#0A2F63]"></i>
                  </div>
                  <div>
                    <h3 className="font-heading text-sm font-semibold text-[#0A2F63] mb-1">Telefon</h3>
                    <p className="text-sm text-foreground-600 mb-1">Hızlı bilgi ve randevu için hemen arayın.</p>
                    <a href="tel:05539591940" className="text-lg font-bold text-[#0A2F63] hover:text-[#2EA44F] transition-colors">0553 959 19 40</a>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-lg p-5 md:p-6 border border-gray-100 shadow-sm">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#2EA44F]/10 rounded-lg shrink-0">
                    <i className="ri-whatsapp-line w-5 h-5 flex items-center justify-center text-[#2EA44F]"></i>
                  </div>
                  <div>
                    <h3 className="font-heading text-sm font-semibold text-[#0A2F63] mb-1">WhatsApp</h3>
                    <p className="text-sm text-foreground-600 mb-2">Hızlı teklif ve bilgi için bize yazın.</p>
                    <a href="https://wa.me/905539591940" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-[#2EA44F] text-white px-4 py-2 rounded-md text-sm font-semibold hover:bg-[#2EA44F]/90 transition-colors">
                      <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center"></i>
                      WhatsApp'tan Yaz
                    </a>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-lg p-5 md:p-6 border border-gray-100 shadow-sm">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#0A2F63]/10 rounded-lg shrink-0">
                    <i className="ri-map-pin-line w-5 h-5 flex items-center justify-center text-[#0A2F63]"></i>
                  </div>
                  <div>
                    <h3 className="font-heading text-sm font-semibold text-[#0A2F63] mb-1">Adres</h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      Güzelyalı, 81201. Sk. Kardelen Sitesi A Blok No 20-a, 01170 Çukurova/Adana
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-lg p-5 md:p-6 border border-gray-100 shadow-sm">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#0A2F63]/10 rounded-lg shrink-0">
                    <i className="ri-map-pin-2-line w-5 h-5 flex items-center justify-center text-[#0A2F63]"></i>
                  </div>
                  <div>
                    <h3 className="font-heading text-sm font-semibold text-[#0A2F63] mb-1">Hizmet bölgeleri</h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      Sarıçam, Çukurova, Seyhan, Yüreğir ve Adana geneli
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-14 md:py-20 bg-background-100">
        <div className="w-full px-4 md:px-6 lg:px-10">
          <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
            <div className="lg:col-span-1">
              <h3 className="font-heading text-xl font-bold text-[#0A2F63] mb-3">Bize ulaşın</h3>
              <p className="text-sm text-foreground-600 mb-4">
                Adres bilgimiz aşağıda yer alır. Yol tarifi için harici Google Maps bağlantısını kullanabilirsiniz.
              </p>
              <a
                href="https://www.google.com/maps/dir/?api=1&destination=G%C3%BCzelyal%C4%B1%2C+81201.+Sk.+Kardelen+Sitesi+A+Blok+No+20-a%2C+01170+%C3%87ukurova%2FAdana"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-[#0A2F63] text-white px-5 py-3 rounded-md text-sm font-semibold hover:bg-[#0A2F63]/90 transition-colors whitespace-nowrap"
              >
                <i className="ri-route-line w-4 h-4 flex items-center justify-center"></i>
                Yol tarifi al
              </a>
            </div>
            <div className="lg:col-span-2 rounded-lg border border-gray-200 bg-white p-6 md:p-8 min-h-72 md:min-h-96 flex flex-col justify-center">
              <div className="max-w-2xl">
                <span className="inline-flex items-center justify-center w-12 h-12 rounded-lg bg-[#0A2F63]/10 text-[#0A2F63] mb-5">
                  <i className="ri-map-pin-line w-6 h-6 flex items-center justify-center"></i>
                </span>
                <h4 className="font-heading text-2xl font-bold text-[#0A2F63] mb-3">Day Temizlik Adana</h4>
                <p className="text-base text-foreground-700 leading-relaxed mb-4">
                  Güzelyalı, 81201. Sk. Kardelen Sitesi A Blok No 20-a, 01170 Çukurova/Adana
                </p>
                <p className="text-sm text-foreground-600 mb-6">
                  Telefon: <a href="tel:05539591940" className="font-semibold text-[#0A2F63] hover:text-[#2EA44F]">0553 959 19 40</a>
                </p>
                <div className="flex flex-col sm:flex-row gap-3">
                  <a href="tel:05539591940" className="inline-flex items-center justify-center gap-2 bg-[#2EA44F] text-white px-5 py-3 rounded-md text-sm font-semibold hover:bg-[#2EA44F]/90 transition-colors whitespace-nowrap">
                    <i className="ri-phone-line w-4 h-4 flex items-center justify-center"></i>
                    Hemen Ara
                  </a>
                  <a href="https://wa.me/905539591940" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 bg-[#0A2F63] text-white px-5 py-3 rounded-md text-sm font-semibold hover:bg-[#0A2F63]/90 transition-colors whitespace-nowrap">
                    <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center"></i>
                    WhatsApp'tan Yaz
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
